import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { days } from '@shared-constants/date-constants';
import { convertSapDateToMoment } from '@shared-helpers/date-helpers';
import { addDecimals } from '@shared-helpers/string-number-helpers';
import { IDayOfWeek } from '@shared-interfaces/dates';

import { Employee } from '../../../scripts/employee';
import { DatahubService } from '../../../services/datahub.service';

interface IPerDiemTotalRow {
  dayName: Capitalize<IDayOfWeek>;
  label: string;
  mealValue: string;
  hotelValue: string;
}

@Component({
  selector: 'app-modal-content-per-diem-totals',
  templateUrl: './modal-content-per-diem-totals.component.html',
  standalone: false,
})
export class ModalContentPerDiemTotalsComponent implements OnInit {
  @Input() public employeeInfo: Employee;
  @Output() public readonly closed = new EventEmitter();

  public weDate = '';
  public readonly rowsForDisplay: IPerDiemTotalRow[] = [
    { dayName: 'Sun', label: 'SU', mealValue: '0', hotelValue: '0' },
    { dayName: 'Mon', label: 'MO', mealValue: '0', hotelValue: '0' },
    { dayName: 'Tue', label: 'TU', mealValue: '0', hotelValue: '0' },
    { dayName: 'Wed', label: 'WE', mealValue: '0', hotelValue: '0' },
    { dayName: 'Thu', label: 'TH', mealValue: '0', hotelValue: '0' },
    { dayName: 'Fri', label: 'FR', mealValue: '0', hotelValue: '0' },
    { dayName: 'Sat', label: 'SA', mealValue: '0', hotelValue: '0' },
  ];

  public totals = {
    meals: '',
    hotels: '',
    grandTotal: '',
  };

  constructor(private readonly datahub: DatahubService) {}

  public ngOnInit(): void {
    this.employeeInfo.perDiemRecords.forEach((record) => {
      if (record.Statkeyfig === 'Z103' || record.Statkeyfig === 'Z104' || record.Statkeyfig === 'Z105') {
        const dayOfWeek = days[convertSapDateToMoment(record.Workdate).day()];
        const row = this.rowsForDisplay.find((r) => r.dayName === dayOfWeek);
        if (row) row.mealValue = addDecimals(row.mealValue, record.Zperdiemamount);
      } else if (record.Statkeyfig === 'Z106') {
        const dayOfWeek = days[convertSapDateToMoment(record.Workdate).day()];
        const row = this.rowsForDisplay.find((r) => r.dayName === dayOfWeek);
        if (row) row.hotelValue = addDecimals(row.hotelValue, record.Zperdiemamount);
      }
    });

    //Calc the totals
    this.totals.meals = this.rowsForDisplay.reduce((prev, curr) => addDecimals(prev, curr.mealValue), '0');
    this.totals.hotels = this.rowsForDisplay.reduce((prev, curr) => addDecimals(prev, curr.hotelValue), '0');
    this.totals.grandTotal = addDecimals(this.totals.meals, this.totals.hotels);
    this.weDate = this.datahub.weDate.getHumanReadableDateString();
  }

  public cancel(): void {
    this.closed.emit();
  }

  public confirm(): void {
    this.closed.emit();
  }
}
